import { StylesDerivedNativeActions } from '@wix/editor-platform-host-integration-apis';
import createDefaultActionDefinition from '../common/actionDefinition/default';
import { createSpacingValidator } from './validator';

export { parseGapValue, parsePaddingValue } from './parser';

const spacingAction = {
  ...createDefaultActionDefinition(StylesDerivedNativeActions.spacingStyles),
  validator: createSpacingValidator(),
};

export default spacingAction;
